import React, { useState } from "react";
import "./DependentInfo.css";
import ClientDashboardWrap from "../Components/ClientDashboardWrap/ClientDashboardWrap";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BackIcon from "../../assets/images/client-dashboard/adddepinfo-banbtnbackicon.svg";
import { useNavigate } from "react-router-dom";
const ClientDashboardAddDependentInfo = () => {
  const [residentialAddresses, setResidentialAddresses] = useState([
    { year: 2020, state: "", from: "", to: "" },
  ]);
  const navigate = useNavigate();
  const addResidentialAddress = (index) => {
    const newYear = residentialAddresses[index]?.year + 1;
    if (!residentialAddresses.some((address) => address.year === newYear)) {
      setResidentialAddresses((prevAddresses) => [
        ...prevAddresses,
        {
          year: newYear,
          state: "",
          from: "",
          to: "",
        },
      ]);
    } else {
      // Handle the case when the year already exists (e.g., show an error message)
      // You can add your own logic here
    }
  };
  const removeResidentialAddress = (index) => {
    setResidentialAddresses((prevAddresses) =>
      prevAddresses.filter((_, i) => i !== index)
    );
  };
  return (
    <ClientDashboardWrap>
      <div className="clientdashboard__depndtinfo_section">
        <div className="clientdashboard__depndtinfo_banner">
          <button
            className="clientdashboard__adddepndtinfo_adddepinfobtn"
            onClick={() => navigate("/client-dashboard/bi-dependent-info")}
          >
            <img src={BackIcon} />
            <span>Back to Dependent Info</span>
          </button>
        </div>
        <div className="clientdashboard__depndtinfo_wrapper">
          <div className="clientdashboard__depndtinfo_innersection">
            <div className="clientdashboard__depndtinfo_inrsecheader">
              Dependent Identity Set
            </div>
            <div className="clientdashboard__depndtinfo_inrsecbody">
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter First Name"
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter Last Name"
                  />
                </div>
              </div>
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Date of birth
                  </label>
                  <input
                    type="date"
                    className="clientdashboard__depndtinfo_inputfield"
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Relationship
                  </label>

                  <CustomDropdown
                    options={["Father", "Mother"]}
                    customStyles={{
                      height: 60,
                      border: "1px solid lightgrey",
                      marginTop: 5,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clientdashboard__depndtinfo_wrapper">
          <div className="clientdashboard__depndtinfo_innersection">
            <div className="clientdashboard__depndtinfo_inrsecheader">
              Dependent Info
            </div>
            <div className="clientdashboard__depndtinfo_inrsecbody">
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    IRS Status
                  </label>
                  <div className="clientdashboard__depndtinfo_radioswrap">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="ssn"
                        control={<Radio />}
                        label="SSN"
                      />
                      <FormControlLabel
                        value="itin"
                        control={<Radio />}
                        label="ITIN"
                      />
                      <FormControlLabel
                        value="applying_itin"
                        control={<Radio />}
                        label="Applying ITIN"
                      />
                      <FormControlLabel
                        value="renewing_itin"
                        control={<Radio />}
                        label="Renewing ITIN"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </div>
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Dependent Visa Type
                  </label>
                  <CustomDropdown
                    options={["F1"]}
                    customStyles={{
                      height: 60,
                      border: "1px solid lightgrey",
                      marginTop: 5,
                    }}
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Days stayed in the US
                  </label>
                  <input
                    type="number"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="EX: 001"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clientdashboard__depndtinfo_wrapper">
          <div className="clientdashboard__depndtinfo_innersection">
            <div className="clientdashboard__depndtinfo_inrsecheader">
              Residential Address(es) during tax year{" "}
            </div>
            <div className="clientdashboard__depndtinfo_isec2wrap">
              <div className="clientdashboard__depndtinfo_innersection2">
                <div className="clientdashboard__depndtinfo_inrsec2header">
                  <div className="clientdashboard__depndtinfo_inrsec2hitem">
                    Tax Year
                  </div>
                  <div className="clientdashboard__depndtinfo_inrsec2hitem">
                    State of Residence
                  </div>
                  <div className="clientdashboard__depndtinfo_inrsec2hitem">
                    From
                  </div>
                  <div className="clientdashboard__depndtinfo_inrsec2hitem">
                    To
                  </div>
                  <div className="clientdashboard__depndtinfo_inrsec2hitem">
                    Option
                  </div>
                </div>
                <div className="clientdashboard__depndtinfo_inrsec2body">
                  {residentialAddresses?.map((item, index) => (
                    <div className="clientdashboard__depndtinfo_inrsec2brow">
                      <div className="clientdashboard__depndtinfo_inrsec2bitem">
                        {item?.year}
                      </div>
                      <div className="clientdashboard__depndtinfo_inrsec2bitem">
                        <input
                          type="text"
                          placeholder="Enter State Name"
                          className="clientdashboard__depndtinfo_is2ifield"
                        />
                      </div>
                      <div className="clientdashboard__depndtinfo_inrsec2bitem">
                        <input
                          type="date"
                          className="clientdashboard__depndtinfo_is2ifield"
                        />
                      </div>
                      <div className="clientdashboard__depndtinfo_inrsec2bitem">
                        <input
                          type="date"
                          className="clientdashboard__depndtinfo_is2ifield"
                        />
                      </div>
                      <div className="clientdashboard__depndtinfo_inrsec2bitem">
                        <div className="clientdashboard__depndtinfo_is2soptions">
                          <div
                            className={`clientdashboard__depndtinfo_is2soptplus`}
                            onClick={() => addResidentialAddress(index)}
                          >
                            +
                          </div>
                          <div
                            className={`clientdashboard__depndtinfo_is2soptminus  ${
                              residentialAddresses?.length < 2
                                ? "clientdashboard__depndtinfo_is2soptdisabled"
                                : ""
                            }`}
                            onClick={() => removeResidentialAddress(index)}
                          >
                            -
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clientdashboard__depndtinfo_wrapper">
          <div className="clientdashboard__depndtinfo_innersection">
            <div className="clientdashboard__depndtinfo_inrsecheader2">
              <div>Day Care Details</div>
              <div className="clientdashboard__depndtinfo_ishsubheading">
                Fees paid to a licensed day care center or family day care for
                care of an infant or pre-schooler
              </div>
            </div>
            <div className="clientdashboard__depndtinfo_inrsecbody">
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Institution Name
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter Institution Name"
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Institution Tax ID
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter Institution Tax ID"
                  />
                </div>
              </div>
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Address
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter Address"
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Apartment
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter Apartment Details"
                  />
                </div>
              </div>
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    City
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter City"
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    State
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter State"
                  />
                </div>
              </div>
              <div className="clientdashboard__depndtinfo_inrsecrow">
                <div className="clientdashboard__depndtinfo_inrseccolleft">
                  <label className="clientdashboard__depndtinfo_inputlbl">
                    Zip
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__depndtinfo_inputfield"
                    placeholder="Enter Zip Code"
                  />
                </div>
                <div className="clientdashboard__depndtinfo_inrseccol"></div>
              </div>
            </div>
          </div>
          <div
            className="clientdashboard__depndtinfo_checkboxitm2"
            style={{ border: "none" }}
          >
            <div className="clientdashboard__depndtinfo_cbicbox">
              {" "}
              <Checkbox
                defaultChecked
                sx={{
                  "&.Mui-checked": {
                    color: "rgba(29, 66, 102, 1)",
                  },
                }}
              />
            </div>
            <div className="clientdashboard__depndtinfo_cbirttxt">
              I declare that the information in this application is true and
              correct
            </div>
          </div>
        </div>

        <br />
        <div className="clientdashboard__depndtinfo_wrapper">
          <div className="clientdashboard__depndtinfo_bottombtns">
            <button className="clientdashboard__depndtinfo_bottombtn1">
              Save
            </button>
            <button className="clientdashboard__depndtinfo_bottombtn2">
              Reset
            </button>
          </div>
        </div>
      </div>
    </ClientDashboardWrap>
  );
};

export default ClientDashboardAddDependentInfo;
